export const START_UPLOAD_ATTACHMENT =
  "bonfire/attachments/START_UPLOAD_ATTACHMENT";
export const END_UPLOAD_ATTACHMENT =
  "bonfire/attachments/END_UPLOAD ATTACHMENT";

export const ADD_ATTACHMENT_REQUEST =
  "bonfire/attachments/ADD_ATTACHMENT_REQUEST";
export const UPLOAD_ATTACHMENTS_COMPLETED =
  "bonfire/attachments/UPLOAD_ATTACHMENTS_COMPLETED";
export const REMOVE_ATTACHMENT = "bonfire/attachments/REMOVE_ATTACHMENT";

export const INITIALIZE_ATTACHMENTS =
  "bonfire/attachments/INITIALIZE_ATTACHMENTS";

// AWS ACTIONS
export const GET_SIGNED_URL = "bonfire/aws/GET_SIGNED_URL";
export const GET_SIGNED_URL_SUCCESS = "bonfire/aws/GET_SIGNED_URL_SUCCESS";
export const GET_SIGNED_URL_FAIL = "bonfire/aws/GET_SIGNED_URL_FAIL";

export const UPLOAD_TO_S3 = "bonfire/aws/UPLOAD_TO_S3";
export const UPLOAD_TO_S3_SUCCESS = "bonfire/aws/UPLOAD_TO_S3_SUCCESS";
export const UPLOAD_TO_S3_FAIL = "bonfire/aws/UPLOAD_TO_S3_FAIL";

interface StartUploadAttachmentAction {
  type: typeof START_UPLOAD_ATTACHMENT;
}

interface EndUploadAttachmentAction {
  type: typeof END_UPLOAD_ATTACHMENT;
}

interface AddAttachmentRequestAction {
  type: typeof ADD_ATTACHMENT_REQUEST;
  attachment: any;
}

interface UploadAttachmentsCompletedAction {
  type: typeof UPLOAD_ATTACHMENTS_COMPLETED;
}

interface RemoveAttachmentAction {
  type: typeof REMOVE_ATTACHMENT;
  attachment: any;
}

interface InitilizeAttachmentsAction {
  type: typeof INITIALIZE_ATTACHMENTS;
}

interface GetSignedUrlAction {
  type: typeof GET_SIGNED_URL;
}

interface GetSignedUrlSuccessAction {
  type: typeof GET_SIGNED_URL_SUCCESS;
  result: {
    signedPutUrl: string;
    publicReadUrl: string;
  };
}

interface GetSignedUrlFailAction {
  type: typeof GET_SIGNED_URL_FAIL;
}

interface UploadToS3Action {
  type: typeof UPLOAD_TO_S3;
}

interface UploadToS3SuccessAction {
  type: typeof UPLOAD_TO_S3_SUCCESS;
}

interface UploadToS3FailAction {
  type: typeof UPLOAD_TO_S3_FAIL;
  error: any;
}

export type AttachmentsAction =
  | StartUploadAttachmentAction
  | EndUploadAttachmentAction
  | AddAttachmentRequestAction
  | UploadAttachmentsCompletedAction
  | RemoveAttachmentAction
  | InitilizeAttachmentsAction
  | GetSignedUrlAction
  | GetSignedUrlSuccessAction
  | GetSignedUrlFailAction
  | UploadToS3Action
  | UploadToS3SuccessAction
  | UploadToS3FailAction;
